/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Indoor_CyclingInputs */

const en_service_type_indoor_cycling = /** @type {(inputs: Service_Type_Indoor_CyclingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indoor cycling`)
};

const pl_service_type_indoor_cycling = /** @type {(inputs: Service_Type_Indoor_CyclingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinning`)
};

/**
* | output |
* | --- |
* | "Indoor cycling" |
*
* @param {Service_Type_Indoor_CyclingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_indoor_cycling = /** @type {((inputs?: Service_Type_Indoor_CyclingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Indoor_CyclingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_indoor_cycling(inputs)
	return en_service_type_indoor_cycling(inputs)
});